function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable prefer-arrow-callback */
import React, { forwardRef } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as styles from '../../styles/radio';
import { jsx as ___EmotionJSX } from "@emotion/core";
function BaseRadio(_ref, ref) {
  var _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? undefined : _ref$checked,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? undefined : _ref$className,
    _ref$defaultChecked = _ref.defaultChecked,
    defaultChecked = _ref$defaultChecked === void 0 ? undefined : _ref$defaultChecked,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? undefined : _ref$disabled,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? undefined : _ref$id,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? undefined : _ref$value,
    _ref$labelContent = _ref.labelContent,
    labelContent = _ref$labelContent === void 0 ? undefined : _ref$labelContent,
    name = _ref.name,
    _ref$isTile = _ref.isTile,
    isTile = _ref$isTile === void 0 ? false : _ref$isTile,
    _ref$tileAppearance = _ref.tileAppearance,
    tileAppearance = _ref$tileAppearance === void 0 ? 'default' : _ref$tileAppearance,
    _ref$ariaInvalid = _ref.ariaInvalid,
    ariaInvalid = _ref$ariaInvalid === void 0 ? undefined : _ref$ariaInvalid,
    _ref$ariaDescribedBy = _ref.ariaDescribedBy,
    ariaDescribedBy = _ref$ariaDescribedBy === void 0 ? undefined : _ref$ariaDescribedBy,
    _ref$ariaLabelledBy = _ref.ariaLabelledBy,
    ariaLabelledBy = _ref$ariaLabelledBy === void 0 ? undefined : _ref$ariaLabelledBy,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? () => {} : _ref$onChange,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? () => {} : _ref$onFocus,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? () => {} : _ref$onBlur,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'regular' : _ref$size,
    _ref$stretched = _ref.stretched,
    stretched = _ref$stretched === void 0 ? 'not-stretched' : _ref$stretched;
  // props to pass to the input
  var radioProps = {
    defaultChecked,
    disabled,
    id,
    name,
    onBlur,
    onClick,
    onChange,
    onFocus,
    value,
    size,
    stretched
  };

  // Don't set checked unless it's passed as a prop or
  // it becomes a controlled component
  if (checked !== undefined) {
    radioProps.checked = checked;
  }
  var labelClasses = classnames({
    'domain-radio__label': true,
    [className]: !!className,
    'is-disabled': disabled,
    isTile,
    'tile-segment': tileAppearance === 'segment'
  });
  var radioClasses = classnames({
    'domain-radio': true,
    'is-disabled': disabled
  });

  // The psuedo label element
  var labelText;
  if (labelContent) {
    labelText = ___EmotionJSX("span", {
      className: "domain-radio__label-text",
      css: styles.labelText({
        isTile,
        tileAppearance,
        size
      })
    }, labelContent);
  }
  return ___EmotionJSX("label", {
    className: labelClasses,
    css: styles.label({
      isDisabled: disabled,
      isTile,
      tileAppearance,
      size,
      stretched
    })
  }, ___EmotionJSX("input", _extends({
    type: "radio",
    className: "domain-radio__input"
  }, radioProps, {
    "aria-invalid": ariaInvalid,
    "aria-describedby": ariaDescribedBy,
    "aria-labelledby": ariaLabelledBy,
    css: styles.input,
    ref: ref
  })), !isTile && ___EmotionJSX("span", {
    className: "domain-radio__label-radio",
    css: styles.labelRadio
  }, ___EmotionJSX("span", {
    className: radioClasses,
    css: styles.radio(!!disabled)
  })), labelText);
}
BaseRadio.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  labelContent: PropTypes.node,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  value: PropTypes.string,
  isTile: PropTypes.bool,
  tileAppearance: PropTypes.oneOf(['default', 'segment']),
  ariaInvalid: PropTypes.bool,
  ariaDescribedBy: PropTypes.string,
  ariaLabelledBy: PropTypes.string,
  size: PropTypes.oneOf(['small', 'mini', 'regular']),
  stretched: PropTypes.oneOf(['not-stretched', 'equal', 'adaptive'])
};
var Radio = /*#__PURE__*/forwardRef(BaseRadio);
export default Radio;